import axios from "axios";
import Swal from 'sweetalert2'
import Vue from 'vue'

let baseApi = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API
});

const Api = function(){
    let token = Vue.$cookies.get('token');
    let locale = 'ar';
    if(token){
        baseApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    baseApi.defaults.headers.common['Locale'] = locale ? locale : 'ar';
    baseApi.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    baseApi.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

   baseApi.interceptors.response.use(function (response) {
    if (response.data.code == 403) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        showConfirmButton: false,
        allowOutsideClick: false,
        text:  response.data.messages[0],
        footer: '<a class="btn btn-info" href="/">Go Back</a>'
      })
    } else {
      return response;
    }
  }, function (error) {
    console.log(error);
    return Promise.reject(error);
  });

    return baseApi;
}
export default Api;
